import { useEffect, useState } from "react";
import { User } from "../types/UserGroup";
import { listUsers } from "./api/UserClient";
import { handleError } from "./ErrorHandling";

// One request for the app's lifetime, shared by every caller: a list of rows
// mounts many owner cells at once. A new user shows up on reload.
let request: Promise<User[] | undefined> | undefined;

/** The org's users: undefined while they load. */
export function useUsers(): User[] | undefined {
    const [users, setUsers] = useState<User[] | undefined>(undefined);

    useEffect(() => {
        if (!request) {
            request = listUsers().catch((error) => {
                request = undefined; // retry on the next mount
                handleError(error);
                return undefined;
            });
        }
        let cancelled = false;
        void request.then((result) => {
            if (!cancelled) setUsers(result);
        });
        return () => {
            cancelled = true;
        };
    }, []);

    return users;
}
